// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news":"news_2AStv"};